import React, { useMemo, useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ShowMore from 'components/shared/show-more'
import StarIcon from 'components/shared/icons/star'
import LocationIcon from './location-icon'

const Heading = ({ address, className, buildingName = '', highList = [], headingData = {}, description }) => {
  const { price_per_category = [], total_spaces = 0 } = headingData
  const [containerHeight, setcontainerHeight] = useState(null)
  const createMarkup = () => {
    return ({
      __html: description
    })
  }

  const containerRef = useRef(null)


  useEffect(() => {
    const { current } = containerRef
    if (current) {
      setcontainerHeight(current.scrollHeight)
    }
  }, [description])

  const data = useMemo(() => {
    const officeSpace = {
      category_name: 'Office Space',
      category_id: 4,
      category_slug: 'traditional-office',
    }
    const isAlreadyExistOfficeSpace = price_per_category.find((x) => x.category_id === 4)
    if (isAlreadyExistOfficeSpace) {
      return price_per_category
    }

    return [officeSpace, ...price_per_category]
  }, [price_per_category])

  const highlights = highList.filter((item) => item.title && item.title.trim())
  const getClassName = (key, last) => {
    return `${key === last ? 'mb-5' : ''
      } mt-4 flex justify-between lg:py-3 lg:mt-0 px-6 lg:items-center items-start lg:flex-row flex-col `
  }

  return (
    <div className={className ?? ''}>
      <h1 className="building-client-page-heading ">{buildingName}</h1>
      <div className="flex items-center lg:mb-8 mb-3 lg:mt-0 mt-3">
        <LocationIcon className="mr-2" />
        {address}
      </div>
      {!!total_spaces && (
        <div className="building-heading-border">
          <div className="flex  py-3 px-6 items-center">
            <strong className="text-xl">{`${total_spaces ?? 0} Spaces`}</strong>
          </div>
          <div className="building-heading-border-top">
            {data?.map((category, key) => {
              const displayContactUsText = category.category_id === 4 && !category?.formattedPrice
              return (
                <div key={key} className={getClassName(key, data.length - 1)}>
                  <span>{category.category_name}</span>
                  {displayContactUsText ? (
                    <p>
                      <a
                        href="#building-inquire-form-id"
                        className="building-heading-gray-text mr-1"
                      >
                        Contact us
                      </a>
                    </p>
                  ) : (
                    <p>
                      <span className="building-heading-gray-text mr-1">Starting at</span>
                      <span className="font-bold">{category.formattedPrice}</span>
                    </p>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      )}
      <div className="building-amenities mt-5 break-words">
        {highlights.map((item, key) => (
          <p key={key} className="text-sm w-full flex items-center px-3 py-1">
            <StarIcon color="#EBA142" className="w-6" />
            <span className="w-11/12 ml-2">{item.title}</span>
          </p>

        ))}
      </div>
      <div>
        <ShowMore
          className="flex flex-col"
          initialHeight={100}
          disabled={containerHeight <= 80}
        >
          <p
            ref={containerRef}
            className="mt-5 text-sm building-description"
            dangerouslySetInnerHTML={createMarkup()}
          ></p>
        </ShowMore>
      </div>
    </div>
  )
}

Heading.propTypes = {
  state: PropTypes.object,
  address: PropTypes.string,
  className: PropTypes.string,
  buildingName: PropTypes.string,
  highList: PropTypes.array,
  headingData: PropTypes.object,
  currency: PropTypes.string,
  description: PropTypes.string,
}

const mapStateToProps = ({ building, ...state }) => {
  return {
    state,
    headingData: building.public.details.headingData,
    currency: building?.public?.listingVenues?.list[0]?.currency,
  }
}
export default connect(mapStateToProps, null)(Heading)
